// extracted by mini-css-extract-plugin
export default {"mainContainer":"Taxes_mainContainer__wExdL","prekidVazenjaNote":"Taxes_prekidVazenjaNote__dPVon","fontSize":"Taxes_fontSize__V+0B7"};